import Grainient from '../components/ui/Grainient'
import styles from './Login.module.css'

export default function Login() {
  const params = new URLSearchParams(window.location.search)
  const error = params.get('error')

  return (
    <div className={styles.page}>
      <div className={styles.grainientBg}>
        <Grainient
          color1="#661a29"
          color2="#cb163a"
          color3="#382323"
          timeSpeed={0.25}
          colorBalance={0}
          warpStrength={1}
          warpFrequency={5}
          warpSpeed={2}
          warpAmplitude={50}
          blendAngle={0}
          blendSoftness={0.05}
          rotationAmount={500}
          noiseScale={2}
          grainAmount={0.13}
          grainScale={2}
          grainAnimated={false}
          contrast={1.1}
          gamma={0.9}
          saturation={0.85}
          centerX={0}
          centerY={0}
          zoom={0.9}
        />
      </div>
      <div className={styles.card}>
        <div className={styles.wordmark}>
          <span className={styles.wordmarkCrown}>👑</span>
          Henry <span>Intelligence</span>
        </div>
        <div className={styles.divider} />
        {error === 'unauthorized' && (
          <p className={styles.error}>Your email is not authorised to access this platform.</p>
        )}
        <a href='/auth/google' className={styles.btn}>
          <svg className={styles.btnIcon} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
            <path fill='#fff' d='M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z'/>
            <path fill='rgba(255,255,255,0.8)' d='M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z'/>
            <path fill='rgba(255,255,255,0.6)' d='M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z'/>
            <path fill='rgba(255,255,255,0.9)' d='M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z'/>
          </svg>
          Sign in with Google
        </a>
      </div>
    </div>
  )
}
